import {localStorageService} from "../storage/local-storage";
import storageKeys from "../storage/storageKeys";
import {MidiDeviceSettings} from "../../models/view/lessonPage/MidiDeviceSettings";

/**
 * @deprecated The original purpose for this class is subsumed by the new way we're using Redux & localStorage.
 */
export class LessonLocalStorage {

  getAllMidiDeviceSettings(): MidiDeviceSettings[] {
    return localStorageService.getJsonItem<MidiDeviceSettings[]>(storageKeys.segmentPlayer_midiDeviceSettingsGroup) ?? [];
  }

  #setAllMidiDeviceSettings(midiDeviceSettings: MidiDeviceSettings[]): void {
    localStorageService.setJsonItem<MidiDeviceSettings[]>(storageKeys.segmentPlayer_midiDeviceSettingsGroup, midiDeviceSettings);
  }

  upsertMidiDeviceSettings(midiDeviceSettings: MidiDeviceSettings): void {
    // Section: if the device already exists, remove it
    const currentSettingsForDevice = this.getMidiDeviceSettingsById(midiDeviceSettings.id);
    if (currentSettingsForDevice) {
      this.#removeMidiDeviceSettings(currentSettingsForDevice);
    }

    // Section: add the new device
    const allMidiDeviceSettings = this.getAllMidiDeviceSettings();
    allMidiDeviceSettings.push(midiDeviceSettings);
    this.#setAllMidiDeviceSettings(allMidiDeviceSettings);
  }

  #removeMidiDeviceSettings(midiDeviceSettings: MidiDeviceSettings): void {
    const allMidiDeviceSettings = this.getAllMidiDeviceSettings();
    const index = allMidiDeviceSettings.findIndex((settings) => settings.id === midiDeviceSettings.id);
    if (index !== -1) {
      allMidiDeviceSettings.splice(index, 1);
    }
    this.#setAllMidiDeviceSettings(allMidiDeviceSettings);
  }

  getMidiDeviceSettingsById(id: string): MidiDeviceSettings | undefined {
    return this.getAllMidiDeviceSettings().find((settings) => settings.id === id);
  }

  getOrCreatePitchDetectionDebuggingIsEnabled(defaultValue: boolean = false): boolean {
    return this.#getOrCreateBooleanValue(storageKeys.segmentPlayer_pitchDetection_debugging_isEnabled, defaultValue);
  }

  getOrCreateHasPitchDetectionDemoSoundEnabledMessageBeenDisplayed(defaultValue: boolean = false): boolean {
    return this.#getOrCreateBooleanValue(storageKeys.segmentPlayer_pitchDetection_hasDemoSoundEnabledWarningBeenDisplayed, defaultValue);
  }

  #getOrCreateBooleanValue(key: string, defaultValue: boolean = false): boolean {
    let result = localStorageService.getJsonItem<boolean>(key);

    if (result === undefined) {
      result = defaultValue;
      localStorageService.setJsonItem(key, result);
    }

    return result;
  }

}

export const lessonLocalStorage = new LessonLocalStorage();
